import React from 'react';
import ExamHistoryContainer from '../../containers/ExamHistoryContainer/ExamResultHistoryContainer';

const ExamHistoryPage: React.FC = () => {
  return <ExamHistoryContainer />;
};

export default ExamHistoryPage;
